import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Features from './components/Features';
import Markets from './components/Markets';
import TradingPlatform from './components/TradingPlatform';
import CopyTradingSection from './components/CopyTradingSection';
import Services from './components/pages/Services';
import Contact from './components/pages/Contact';
import CopyTrading from './components/pages/CopyTrading';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import About from './components/pages/About';
import StockTrading from './components/pages/StockTrading';
import CryptoTrading from './components/pages/CryptoTrading';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        
        <Routes>
          {/* Home Page */}
          <Route path="/" element={
            <>
              <Hero />
              <AboutUs />
              <Features />
              <Markets />
              <TradingPlatform />
              <CopyTradingSection />
            </>
          } />
          
          {/* About Page */}
          <Route path="/about" element={<About />} />
          
          {/* Services Page */}
          <Route path="/services" element={<Services />} />
          
          {/* Trading Pages */}
          <Route path="/stock-trading" element={<StockTrading />} />
          <Route path="/crypto-trading" element={<CryptoTrading />} />
          
          {/* Copy Trading Page */}
          <Route path="/copy-trading" element={<CopyTrading />} />
          
          {/* Contact Page */}
          <Route path="/contact" element={<Contact />} />
          
          {/* Terms Page */}
          <Route path="/terms" element={<Terms />} />
          
          {/* Privacy Page */}
          <Route path="/privacy" element={<Privacy />} />
          
          {/* 404 Page - Redirect to Home */}
          <Route path="*" element={
            <>
              <Hero />
              <AboutUs />
              <Features />
              <Markets />
              <TradingPlatform />
              <CopyTradingSection />
            </>
          } />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
